import { render, staticRenderFns } from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=template&id=0823c6c2&scoped=true&"
import script from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=script&lang=js&"
export * from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=style&index=0&id=0823c6c2&lang=scss&scoped=true&"
import style1 from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=style&index=1&lang=css&"
import style2 from "./RevenueDefaultPricingTableReadOnly.vue?vue&type=style&index=2&id=0823c6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823c6c2",
  null
  
)

export default component.exports